import { render, staticRenderFns } from "./EstablishmentViewWarehouseProducts.vue?vue&type=template&id=6d975550"
import script from "./EstablishmentViewWarehouseProducts.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewWarehouseProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports